var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"fact-card pa-2",class:{ selected: _vm.fact.selected },on:{"click":_vm.onChange}},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.fact.title_sve))]),_c('p',[_vm._v(_vm._s(_vm.fact.text_sve))])])}
var staticRenderFns = []

export { render, staticRenderFns }